import { decodeBase64Urlsafe, encodeUTF8 } from 'vault-crypto';

/**
 * Extracts token version from JWT header for legacy tokens without tokenVersion field.
 * Only needs to support current JWT format - future tokens will have tokenVersion.
 *
 * @param token - The JWT token string
 * @returns The token version (2 or 3), defaults to 2 for legacy/malformed tokens
 */
export default function extractTokenVersionFromJwt(token: string): number {
  try {
    const [headerBase64] = token.split('.');
    if (!headerBase64) return 2;

    // Handle URL-safe base64 encoding and decode
    const headerBytes = decodeBase64Urlsafe(headerBase64);
    const headerJson = encodeUTF8(headerBytes);
    const header = JSON.parse(headerJson) as { 'hl-version'?: string };

    const version = header['hl-version'];
    if (version === '3') return 3;
    return 2;
  } catch {
    return 2;
  }
}
